<template>
  <div class="page-header-index-wide">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view class="keep-alive"   />
    </keep-alive>
    <route-view v-else ></route-view>
  </div>
</template>

<script>
  import PageLayout from '@/components/page/PageLayout'
  import RouteView from '@/components/layouts/RouteView'
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    components: {
      RouteView,
      PageLayout
    },
    mixins: [mixinDevice],
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>

<style lang="less" scoped>

</style>